export const validateField = (errors, inputName) => {
    if (inputName in errors) {
        return {
            helperText: errors[inputName].message,
            error: true,
        };
    }
};
